import React, { useState } from 'react'
import {IconButton} from '@material-ui/core'
import styles from './ImagesCollection.module.css'
import Tooltip from '@material-ui/core/Tooltip';

function ImagesCollection({SliderData}) {

    const [current, setCurrent] = useState(0);
    const length = SliderData.length;

    const nextSlide = () => {
        setCurrent(current === length - 1 ? 0 : current + 1);
    };

    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1);
    };

    if (!Array.isArray(SliderData) || SliderData.length <= 0) {
        return null;
    }

    return (
        <div className={styles.component}>
                <Tooltip title={"Previous"}>
                    <IconButton className={styles.previousButton} onClick={nextSlide}>
                        <i className="fas fa-chevron-left"></i>
                    </IconButton>
                </Tooltip>
                

                {
                    SliderData.map((slide, index) => {
                        return (
                            <div
                                className={index === current ? `${styles.slide } ${styles.slideActive}` : styles.slide}
                                key={index}
                            >
                                {index === current && (
                                    <img src={slide.image} alt="image" className={styles.image}/>
                                )}
                            </div>
                        );
                    })
                }
                <Tooltip title={"Next"} onClick={prevSlide}>
                    <IconButton className={styles.nextButton}>
                        <i className="fas fa-chevron-right"></i>
                    </IconButton>
                </Tooltip>

                <div className={styles.buttonsMob}>
                    <Tooltip title={"Previous"}>
                        <IconButton className={styles.previousButtonMob} onClick={nextSlide}>
                            <i className="fas fa-chevron-left"></i> <span className={styles.buttonLabel}>Previous</span>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={"Next"} onClick={prevSlide}>
                        <IconButton className={styles.nextButtonMob}>
                            <span className={styles.buttonLabel}>Next</span><i class="fas fa-chevron-right"></i>
                        </IconButton>
                    </Tooltip>
                </div>
            
        </div>
    )
}

export default ImagesCollection
